import React from "react";
import styles from './Radio.module.scss';
import RadioCircle from './components/radioCircleSvg';
import {Else, If, Then, When} from 'react-if';
import OkRadioCircle from './components/okRadioCircle';
import NotOkRadioCircle from './components/notOkRadioCircle';
import ConditionalLink from "gui/components/conditionalLink/ConditionalLink";


export interface IRadioProps {
  setState?: (boolean: boolean) => void;
  label?: string;
  okMode?: boolean;
  state?: boolean;
  labelInMiddleMode?: boolean;
  labelTrue?: string;
  labelFalse?: string;
  linkTrue?: string;
  linkFalse?: string;
  radioSelectedIcon?: any;
  radioNotSelectedIcon?: any;
}


const Radio = (props: IRadioProps) => {
  return (
    <span className={`${styles.Radio} ${props.labelInMiddleMode ? styles.labelInMiddleMode : ''}`.trim()}
          onClick={() => props.setState(!props.state)}>
      <If condition={!!props.okMode}>
        <Then>
          {() => <>
            <NotOkRadioCircle
              state={!props.state}
              labelTrue={props.labelTrue}
              labelFalse={props.labelFalse}
            />
            <When condition={props.labelInMiddleMode}>
              {() => props.label}
            </When>
            <OkRadioCircle
              state={props.state}
              labelTrue={props.labelTrue}
              labelFalse={props.labelFalse}
            />
          </>}
        </Then>
        <Else>
               {() => <>
                 <ConditionalLink to={props.linkTrue}>
                   <div>

                     <RadioCircle
                       state={props.state}
                       radioSelectedIcon={props.radioSelectedIcon}
                       radioNotSelectedIcon={props.radioNotSelectedIcon}
                     />
                   </div>
                   {props.labelTrue ? <div className={styles.label}>{props.labelTrue}</div> : ''}
                 </ConditionalLink>
                 <When condition={props.labelInMiddleMode}>
                   {() => props.label}
                 </When>
                 <ConditionalLink to={props.linkFalse}>
                   <div>

                     <RadioCircle
                       state={!props.state}
                       radioSelectedIcon={props.radioSelectedIcon}
                       radioNotSelectedIcon={props.radioNotSelectedIcon}
                     />
                   </div>
                   {props.labelFalse ? <div className={styles.label}>{props.labelFalse}</div> : ''}
                 </ConditionalLink>
               </>}
        </Else>
      </If>

    </span>
  );
};

Radio.defaultProps = {
  okMode: false,
  labelInMiddleMode: false,
  setState: () => {
  },
};

export default Radio;
